import styled from 'styled-components';

import MetricDetailHeader from 'components/insights/layout/details/MetricDetailHeader';

const TableHeader = styled(MetricDetailHeader)`
  margin-bottom: 24px;
`;

export default TableHeader;
